const PERMISSION_KEY= "notification:notification_msg_template";
const PAGE_URL = {
    NOTIFICATION_MSG_TEMPLATE_PAGE: "/admin/notification/notification-msg-template"
}

export {PERMISSION_KEY, PAGE_URL}

